import { Expose } from "class-transformer";

export class ReportTimeStatsDto {
  @Expose()
  totalMinutes: number;

  @Expose()
  averageMinutes: number;
}
